export const AUD_MOBILE_REDESIGN_OBJECTCARD = 'aud_mobile_bx766_objectcard_redesign';

export const EXPERIMENTS: string[] = [AUD_MOBILE_REDESIGN_OBJECTCARD];
